import React from 'react';

export const ConfigErrorScreen = ({ message, details = [] }) => (
  <main className="min-h-screen bg-zinc-950 text-zinc-100 flex items-center justify-center p-6">
    <section className="w-full max-w-2xl rounded-xl border border-rose-500/20 bg-zinc-900 p-6">
      <h1 className="text-xl font-semibold text-rose-400">
        Configuration Error
      </h1>
      <p className="mt-3 text-zinc-300 text-sm">
        The application could not start because runtime configuration is invalid.
      </p>
      <p className="mt-3 text-zinc-400 text-sm">{message}</p>
      {details.length > 0 && (
        <ul className="mt-4 list-disc pl-6 text-zinc-300 text-sm space-y-1">
          {details.map((detail) => (
            <li key={detail}>{detail}</li>
          ))}
        </ul>
      )}
      <p className="mt-6 text-xs text-zinc-600">
        Verify <code className="font-mono bg-zinc-800 px-1.5 py-0.5 rounded text-zinc-400">config.json</code> and redeploy.
      </p>
    </section>
  </main>
);
